import { styled } from "@mui/material"
import Box from "@mui/material/Box"
import InfiniteHorizontalScroller from "components/InfiniteHorizontalScroller"
import { ActivityIndicator } from "components/activity-indicator"
import TeamMemberCard from "components/team-members/TeamMemberCard"
import TeamMemberCardDialog from "components/team-members/TeamMemberCardDialog"
import { UseMoreParams } from "models/convention-api/types"
import ConventionTeamMember from "models/convention-api/v1/ConventionTeamMember"
import React, { useState } from "react"
import { pxToRem } from "utils/helpers"

interface ITeamsList {
  filter: UseMoreParams["filter"]
}

const TeamsList = (props: ITeamsList) => {
  const { filter } = props
  const [readMoreTeamMember, setReadMoreTeamMember] = useState<null | ConventionTeamMember>(null)
  const teamMembers = ConventionTeamMember.useAll(() => ({
    filter,
  }))
  if (!teamMembers.data) {
    return (
      <Box display="flex" flexDirection="column" minHeight="400px">
        <ActivityIndicator />
      </Box>
    )
  }

  if (teamMembers.data?.length <= 0) {
    return null
  }

  return (
    <>
      <InfiniteHorizontalScroller
        hasMore={false}
        loadMore={() => {}}
        loading={false}
        title="Meet the Team"
        emptyStateMessage="No Teams found">
        {teamMembers.data.map((teamMember) => (
          <_TeamCardContainer key={teamMember.id}>
            <TeamMemberCard teamMember={teamMember} onReadMore={setReadMoreTeamMember} />
          </_TeamCardContainer>
        ))}
      </InfiniteHorizontalScroller>
      {readMoreTeamMember && (
        <TeamMemberCardDialog
          teamMember={readMoreTeamMember}
          onClose={() => setReadMoreTeamMember(null)}
        />
      )}
    </>
  )
}

export default TeamsList

const _TeamCardContainer = styled(Box)(() => ({
  width: "100%",
  marginRight: pxToRem(20),
  marginBottom: pxToRem(4),
}))
